import styled from "@emotion/styled";

export const Title = styled.p`
  margin: 0px;
  font-size: 14px;
  font-weight: 700;
  color: #253858;
`;

export const FilterAccounts = styled.div`
  display: grid;
  gap: 24px;
`;

export const Flex = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #c5c8ef;
`;
